<template>
  <div class="second-step">
    <FacilityContractForm
        ref="facilityContractForm"
        @dialogClosed="() => {$emit('dialogClosed')}"
        @cancelDialog="cancelDialog"
        hide-button
        :isGlobal="true"
    />
  </div>
</template>

<script>
import FacilityContractForm from '@/modules/book/views/facility/facility/formDialogs/form/FacilityContractForm.vue';

export default {
  name: 'CreateGlobalContractStep',
  components: {FacilityContractForm},
  data() {
    return {
      inputData: {}
    }
  },
  methods: {
    save() {
      this.$refs.facilityContractForm.updateForm();
    },
    setInputData(inputData) {
      this.inputData = inputData;
      this.$refs.facilityContractForm.uploadAsUrl(inputData.file);
      this.$refs.facilityContractForm.loadEnums();
    },
    cancelDialog() {
      this.$refs.facilityContractForm.cleanupDialogForm();
      this.inputData = {}
    }
  }
}
</script>